module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/demos/inner-pages/blog-article-5dc79d85870cda83c7495150599902f5.png";